import React, { useState, useEffect } from "react";
import { Input, Form, Spin, Select, DatePicker } from "antd";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import ModalComponent from "../../../components/global/modal/ModalComponent";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { AddCreditTransactionApi, GetCreditInOutTransactionApi, GetUserNameByTerminalIdAdpi } from "../../../api/request/credit";
import moment from "moment";
import MyPagination from "../../../components/global/pagination/Pagination";
import toast from "react-hot-toast";
import columns from "../../../columns/Credit";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";
const { Search } = Input;
const { RangePicker } = DatePicker;


export default function Credit() {

    const creditPermissions = useModulePermissions('wallet', 'credit');
    const canCreate = !!creditPermissions.create;

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isCreditOpen, setIsCreditOpen] = useState(false);
    const [isAddCreditLoading, setIsAddCreditLoading] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [tearminalId, setTearminalId] = useState(null);
    const [isEnable, setIsEnable] = useState(true)
    const [search, setSearch] = useState("");
    const [searchText, setSearchText] = useState("");
    const [dates, setDates] = useState([]);
    const [creditType, setCreditType] = useState('');


    const options = [
        { label: 'Credit In', value: 8 },
        { label: 'Credit Out', value: 9 },
    ];

    const creditTypeFilterOptions = [
        { label: 'All', value: '' },
        { label: 'Credit In', value: 'CreditIn' },
        { label: 'Credit Out', value: 'CreditOut' },
    ];

    const fetchCreditInOutTransaction = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FilterText: creditType ? creditType : "",
                FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
                ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
            }
            setIsLoading(true);
            const { data } = await GetCreditInOutTransactionApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return {
                        ...item,
                        createdDate: moment(item?.createdDate).format('DD-MM-YYYY, LT'),
                    }
                }))
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const handleLiveAccountChange = async (terminalId) => {
        setTearminalId(terminalId);
        try {
            setIsSearchLoading(true);
            const { data } = await GetUserNameByTerminalIdAdpi(terminalId);
            if (data?.success) {
                form.setFieldsValue({ customerName: data?.data?.fullName });
                setIsEnable(false);
            }
            setIsSearchLoading(false);
        } catch (error) {
            setIsSearchLoading(false);
            toast.error(error?.response?.data?.message);
            form.resetFields();
        }
    };

    const handleSubmit = async (value) => {
        try {
            setIsAddCreditLoading(true);
            const params = {
                ...value,
                Amount: Number(value?.Amount),
                TearminalId: Number(value?.TearminalId),
                TransactionType: Number(value?.TransactionType),
            }
            delete params.customerName;
            const { data } = await AddCreditTransactionApi(params);
            if (data?.success) {
                toast.success(data?.message)
                setIsCreditOpen(false);
                form.resetFields();
                fetchCreditInOutTransaction();
            }
            setIsAddCreditLoading(false);
        }
        catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsAddCreditLoading(false);
        }
    }

    useEffect(() => {
        fetchCreditInOutTransaction();
    }, [page, pageSize, dates, searchText, creditType]);

    useEffect(() => {
        setPage(1);
    }, [searchText, creditType, dates]);

    useEffect(() => {
        if (!isCreditOpen) {
            form.resetFields();
        }
    }, [isCreditOpen]);

    return (
        <div>
            <div className="flex flex-col sm:flex-row sm:justify-end gap-3 flex-wrap items-stretch sm:items-center">
                <div className="ant-select-selector-white w-full sm:w-auto">
                    <Select
                        size="large"
                        style={{ width: '100%', minWidth: 150, height: 40 }}
                        placeholder="Credit Type"
                        value={creditType}
                        onChange={(value) => setCreditType(value)}
                        options={creditTypeFilterOptions}
                        allowClear
                    />
                </div>
                <div className="w-full sm:w-auto">
                    <RangePicker
                        size="large"
                        className="w-full h-[40px]"
                        format="DD-MM-YYYY"
                        onChange={(dates) => setDates(dates || [])}
                        disabledDate={(current) => current && current > moment().endOf('day')}
                    />
                </div>
                <div className="input-white w-full sm:w-[300px] sm:shrink-0">
                    <Input
                        size="large"
                        style={{ width: '100%', height: 40 }}
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onPressEnter={() => setSearchText(search)}
                        prefix={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                class="w-5 h-5"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        }
                        suffix={
                            search && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => {
                                        setSearchText("");
                                        setSearch("");
                                    }}
                                    viewBox="0 0 24 24"
                                    fill="#bebebe"
                                    className="size-5 cursor-pointer duration-300 hover:fill-[#969595]"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            )
                        }
                    />
                </div>
                {canCreate && <div className="w-full sm:w-auto">
                    <button onClick={() => setIsCreditOpen(true)} className="export-btm flex bg-primary text-sm text-white font-medium uppercase px-6 rounded-lg themeHover duration-400 w-full sm:w-auto justify-center items-center h-[40px]" size="large" >
                        <img src="assets/icons/add_icon.svg" alt="icon" className="mr-2" width={15} />
                        Add New Credit
                    </button>
                </div>}
            </div>

            <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">Credit In-Out <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${totalRecord})`}</span></p>
                </div>
                <div className="mt-6 mb-6 ">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    <MyPagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                </div>


                {/* Add New Credit */}
                <ModalComponent isOpen={isCreditOpen} setIsOpen={setIsCreditOpen} title={<div className="font-bold text-lg">Add New Credit</div>} onCancel={() => setIsCreditOpen(false)}>
                    <Form className="w-full flex flex-col justify-center gap-3" autoComplete="off" form={form} onFinish={handleSubmit}>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Live Account</label>
                            <Form.Item name="TearminalId" rules={[{ required: true, message: "Please enter account number" }]} >
                                <Search placeholder="input search text" value={tearminalId} enterButton="Search" size="large" loading={isSearchLoading}
                                    onSearch={handleLiveAccountChange} />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Customer Name</label>
                            <Form.Item name="customerName">
                                <Input disabled={isEnable} readOnly placeholder="Enter customer name" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="grid sm:grid-cols-2 gap-2">
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Amount</label>
                                <Form.Item name="Amount" rules={[
                                    { required: true, message: "Please enter amount" },
                                    { pattern: /^\d+(\.\d{1,2})?$/, message: "Please enter a valid number" },
                                ]} >
                                    <Input stringMode={false} disabled={isEnable} placeholder="Enter amount" className="mt-1 w-full py-2" />
                                </Form.Item>
                            </div>
                            <div className="ant-select-selector-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Credit Type</label>
                                <Form.Item name="TransactionType" rules={[{ required: true, message: "Please select credit type" }]} >
                                    <Select disabled={isEnable} placeholder="Choose An Account" className="mt-1 w-full " options={options} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Note</label>
                            <Form.Item name="Comment">
                                <Input disabled={isEnable} placeholder="Enter Note" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>

                        <div className="flex justify-end mt-8">
                            <LoadableButton
                                className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                                disabled={isAddCreditLoading}
                                type="Submit"
                                lable="Add"
                                isLoading={isAddCreditLoading}
                                loadingLable="Adding..."
                            />
                        </div>
                    </Form>
                </ModalComponent>
            </div>
        </div>
    );
}